import useUserStore from "./userStore";

export default () => {
  const userStore = useUserStore();
  return {
    userStore,
  }
}